<template>
  <div class="login-page" v-if="show">
    <div class="login-card">
      <div class="login-logo">ProductsDB<span class="reg">®</span></div>
      <p class="login-sub">Sign in to continue</p>

      <form @submit.prevent="logIn">
        <div class="form-group">
          <label for="login-email">E-mail</label>
          <input
            id="login-email"
            type="text"
            v-model="email"
            autocomplete="username"
            placeholder="you@brandclub.lt"
          />
        </div>

        <div class="form-group">
          <label for="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            v-model="password"
            autocomplete="current-password"
            placeholder="Your password"
            @keyup.enter="logIn"
          />
        </div>

        <div class="form-row">
          <a href="#" class="forgot" @click.prevent>Forgot Password?</a>
        </div>

        <div v-if="responseMessage" class="login-error">{{ responseMessage }}</div>

        <button
          type="submit"
          class="login-btn"
          :disabled="submitting || !email || !password"
        >
          {{ submitting ? "Signing in..." : "Login" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  data: () => ({
    show: true,
    email: "",
    password: "",
    responseMessage: "",
    submitting: false,
  }),
  methods: {
    async logIn() {
      this.responseMessage = "";
      if (!this.email || !this.password) {
        this.responseMessage = "E-mail and password are required.";
        return;
      }
      this.submitting = true;
      localStorage.removeItem("token");
      this.$store
        .dispatch("logIn", {
          email: this.email,
          password: this.password,
        })
        .then(async (response) => {
          this.show = false;
          var promise = new Promise((resolve) => {
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + response.data.token;
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("user-id", response.data.user.id);
            localStorage.setItem("permissions", response.data.user.permissions);
            localStorage.setItem("initials", response.data.user.credentials);
            localStorage.setItem("uniqueCode", response.data.user.uniqueNumber);
            localStorage.setItem("homeRefresh", 0);
            localStorage.setItem("entrySource", "direct");
            resolve(response);
          });
          await promise.then((response) => {
            setTimeout(
              this.$router.push("/?bc-auth-token=" + response.data.token),
              3000
            );
          });
        })
        .catch((error) => {
          this.submitting = false;
          this.responseMessage =
            (error.response && error.response.data) ||
            "Login failed. Please try again.";
          this.password = "";
        });
    },
  },
};
</script>

<style scoped>
.login-page {
  --primary: #2563eb;
  --secondary: #8b5cf6;
  --accent: #06b6d4;
  --dark: #0f172a;
  --dark-light: #1e293b;
  --gray: #64748b;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background: linear-gradient(135deg, var(--dark) 0%, var(--dark-light) 100%);
}
.login-card {
  width: 100%;
  max-width: 420px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 2.75rem 2.25rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}
.login-logo {
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--primary), var(--accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.reg {
  font-size: 0.28em;
  vertical-align: super;
  font-weight: 700;
  -webkit-text-fill-color: #ffffff;
}
.login-sub {
  text-align: center;
  color: var(--gray);
  margin: 0.4rem 0 2rem;
  font-size: 0.95rem;
}
.form-group {
  margin-bottom: 1.25rem;
}
.form-group label {
  display: block;
  color: #cbd5e1;
  font-size: 0.85rem;
  margin-bottom: 0.45rem;
}
.form-group input {
  width: 100%;
  padding: 0.85rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #ffffff;
  font-size: 1rem;
  box-sizing: border-box;
  transition: border-color 0.2s, background 0.2s;
}
.form-group input::placeholder {
  color: #64748b;
}
.form-group input:focus {
  outline: none;
  border-color: var(--primary);
  background: rgba(255, 255, 255, 0.08);
}
.form-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.25rem;
}
.forgot {
  color: var(--accent);
  font-size: 0.85rem;
  text-decoration: none;
}
.forgot:hover {
  text-decoration: underline;
}
.login-error {
  background: rgba(239, 68, 68, 0.12);
  border: 1px solid rgba(239, 68, 68, 0.4);
  color: #fca5a5;
  padding: 0.7rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  margin-bottom: 1.25rem;
}
.login-btn {
  width: 100%;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  color: #ffffff;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s, opacity 0.2s;
}
.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(37, 99, 235, 0.4);
}
.login-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
@media (max-width: 480px) {
  .login-card {
    padding: 2rem 1.25rem;
  }
  .login-logo {
    font-size: 1.7rem;
  }
}
</style>
